import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles, withTheme } from '@material-ui/core';
import { withRouter } from 'react-router-dom';

class PublicLayout extends PureComponent {
    static propTypes = {
        children: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired
    };

    render() {
        const { children, classes } = this.props;
        return (
            <div className="d-flex flex-fill flex-column">
                <div className={classes.containerPublicLayout}>{children}</div>
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}

const styles = theme => ({
    containerPublicLayout: {
        height: '100vh'
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}), dispatch)
    )(withStyles(styles, { withTheme: true })(PublicLayout))
);



// WEBPACK FOOTER //
// ./layouts/Public/index.js